import Vue from 'vue'
import Router from 'vue-router'
const Main = () => import('../components/main')
const Error404 = () => import('../components/404')
const Login = () => import('../views/Login')
const Profile = () => import('../views/Profile')
const ForgotPass = () => import('../views/Forgot_pass')

const Dashboard = () => import('../views/Dashboard')

// const Blankpage = () => import('../views/Blank_page')
const Vendor = () => import('../views/vendor')
const Customer = () => import('../views/customer')

const Setting = () => import('../views/setting')
const RoleMenage = () => import('../views/role_management')
const RoleList = () => import('../views/role_list')
const ManageUser = () => import('../views/manage_user')
const ReportSale = () => import('../views/report_sale')
const Calendar = () => import('../views/calendar_view')

const ItemList = () => import('../views/item_list')
const ManageItem = () => import('../views/manage_item')

// ราคากลาง
const ItemPriceList = () => import('../views/item_price_list')
const ManagePriceItem = () => import('../views/manage_price_item')

const ManageBill = () => import('../views/manage_bill')
const ManageCategory = () => import('../views/manage_category')
const ManageStorage = () => import('../views/manage_storage')
const ReceiveList = () => import('../views/receive_list')
const ReturnList = () => import('../views/return_list')
const ReportExpend = () => import('../views/report_expend')
const ReportCostSale = () => import('../views/report_cost_sale')
const ReportCostStandard = () => import('../views/report_cost_standard')
const ReportSaleItem = () => import('../views/report_sale_item')
const ReportProductMovement = () => import('../views/report_product_movement')
const ReportDaily = () => import('../views/report_daily')
const ReportSaleSummary = () => import('../views/report_summary_sale')
const ReportStock = () => import('../views/report_stock')
const ReportHoldingCus = () => import('../views/report_holding_cus')
const ReportCancelBill = () => import('../views/report_bill_cancel')
const ReportHoldingRemain = () => import('../views/report_holding_remain')
const ReportHoldingInvoice = () => import('../views/report_holding_invoice')
const ReportSaleByCustomer = () => import('../views/report_sale_by_customer')
const ReportIncome = () => import('../views/report_income')
const ReportStockStandard = () => import('../views/report_stock_standard')
const ReportYearlySale = () => import('../views/report_yearly_sale')
const ReportCalculateRice = () => import('../views/report_calculate_rice')
const PaymentCreditBill = () => import('../views/payment_credit_bill')
const PrintInv = () => import('../views/print_inv')
const ReportSaleType = () => import('../views/reportsaletype')
const UserMenagement = () => import('../views/user_list')
const AdjustList = () => import('../views/adjust_item')
const StkManage = () => import('../views/stock_manage')
const StkGetManage = () => import('../views/stock_get_manage')
const StandardList = () => import('../views/standart_list')
// const AdjustItem = () => import('../views/adjust_item')
// const ShortStorage = () => import('../views/shot_storage')
const ReportStkList = () => import('../views/report_stk')
const ReportStkEggList = () => import('../views/report_stk_egg')
const StkBalance = () => import('../views/stk_balance')
const StkAmount = () => import('../views/stk_amount')
const TaxInvoice = () => import('../views/tax_invoice')

const RiceStk = () => import('../views/rice_stk');

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
const titlename = ' | POS MIS'

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  base: __dirname,
  routes: [
    {
      path: '/',
      redirect: '/',
      name: 'Main',
      component: Main,
      children: [
        {
          path: '/',
          name: 'dashboard',
          component: Dashboard,
          meta: { title: 'Dashboard', group_id: 5, menu_id: 0 }
        },
        {
          path: '/report_yearly_sale',
          name: 'report_yearly_sale',
          component: ReportYearlySale,
          meta: { title: 'รายงานสรุปยอดขายประจำเดือน', group_id: 16, menu_id: 0 }
        },
        {
          path: '/report_calculate_rice',
          name: 'report_calculate_rice',
          component: ReportCalculateRice,
          meta: { title: 'รายงานคำนวณข้าวนึ่ง', group_id: 17, menu_id: 0 }
        },
        {
          path: '/itemlist',
          name: 'itemlist',
          component: ItemList,
          meta: { title: 'จัดการสินค้า', group_id: 6, menu_id: 2 }
        },
        {
          path: '/manageitem/:branch_id/:id',
          name: 'manageitem',
          component: ManageItem,
          meta: { title: 'ข้อมูลสินค้า', group_id: 2, menu_id: 2 }
        },
        {
          path: '/itemprice',
          name: 'itemprice',
          component: ItemPriceList,
          meta: { title: 'จัดการราคากลาง', group_id: 20, menu_id: 1 }
        },
        {
          path: '/rice_stk',
          name: 'rice_stk',
          component: RiceStk,
          meta: { title: 'จัดการข้าวหม่า', group_id: 20, menu_id: 2 }
        },
        {
          path: '/managepriceitem/:id',
          name: 'managepriceitem',
          component: ManagePriceItem,
          meta: { title: 'ข้อมูลสินค้าราคากลาง', group_id: 7, menu_id: 4 }
        },
        {
          path: '/managecategory',
          name: 'managecategory',
          component: ManageCategory,
          meta: { title: 'จัดการหมวดหมู่', group_id: 2, menu_id: 2 }
        },
        {
          path: '/receivelist',
          name: 'receivelist',
          component: ReceiveList,
          meta: { title: 'บันทึกรับสินค้าเข้า', group_id: 6, menu_id: 3 }
        },
        {
          path: '/managestorage/:branch_id/:code',
          name: 'managestorage',
          component: ManageStorage,
          meta: { title: 'รับสินค้าเข้า', group_id: 2, menu_id: 3 }
        },
        {
          path: '/returnlist',
          name: 'returnlist',
          component: ReturnList,
          meta: { title: 'บันทึกส่งคืนสินค้า', group_id: 2, menu_id: 4 }
        },
        {
          path: '/report_sale',
          name: 'reportsale',
          component: ReportSale,
          meta: { title: 'รายงานขายประจำวัน', group_id: 11, menu_id: 5 }
        },
        {
          path: '/reportitem',
          name: 'reportitem',
          component: ReportSaleItem,
          meta: { title: 'ยอดขายสินค้าประจำวัน', group_id: 6, menu_id: 17 }
        },
        {
          path: '/reportcoststandard',
          name: 'reportcoststandard',
          component: ReportCostStandard,
          meta: { title: 'รายงานต้นทุนมาตราฐาน', group_id: 6, menu_id: 23 }
        },
        {
          path: '/reportcostofsales',
          name: 'reportcostofsales',
          component: ReportCostSale,
          meta: { title: 'รายงานกำไรขั้นต้น', group_id: 6, menu_id: 6 }
        },
        {
          path: '/reportexpend',
          name: 'reportexpend',
          component: ReportExpend,
          meta: { title: 'รายงานค่าใช้จ่าย', group_id: 6, menu_id: 8 }
        },
        {
          path: '/reportstock',
          name: 'reportstock',
          component: ReportStock,
          meta: { title: 'รายงานสต๊อกสินค้า', group_id: 6, menu_id: 9 }
        },
        {
          path: '/reportmovement',
          name: 'reportmovement',
          component: ReportProductMovement,
          meta: { title: 'รายงานเคลื่อนไหวสินค้า', group_id: 6, menu_id: 11 }
        },
        {
          path: '/reportdaily',
          name: 'reportdaily',
          component: ReportDaily,
          meta: { title: 'รายงานนำส่งเงิน', group_id: 6, menu_id: 7 }
        },
        {
          path: '/reportsalesummary',
          name: 'reportsalesummary',
          component: ReportSaleSummary,
          meta: { title: 'รายงานสรุปการขาย', group_id: 6, menu_id: 10 }
        },
        {
          path: '/reportholdingcus',
          name: 'reportholdingcus',
          component: ReportHoldingCus,
          meta: { title: 'รายงานพักบิลตามวันที่', group_id: 6, menu_id: 12 }
        },
        {
          path: '/reportbillcancel',
          name: 'reportbillcancel',
          component: ReportCancelBill,
          meta: { title: 'รายงานยกเลิกบิล', group_id: 6, menu_id: 15 }
        },
        {
          path: '/reportholdingremain',
          name: 'reportholdingremain',
          component: ReportHoldingRemain,
          meta: { title: 'รายงานพักบิลค้างชำระ', group_id: 6, menu_id: 13 }
        },
        {
          path: '/reportholdinginvoice',
          name: 'reportholdinginvoice',
          component: ReportHoldingInvoice,
          meta: { title: 'รายงานสรุปสถานะใบพักบิล', group_id: 6, menu_id: 21 }
        },
        {
          path: '/reportsalebycustomer',
          name: 'reportsalebycustomer',
          component: ReportSaleByCustomer,
          meta: { title: 'รายงานสรุปยอดขายตามลูกค้า', group_id: 6, menu_id: 14 }
        },
        {
          path: '/reportsaletype',
          name: 'reportsaletype',
          component: ReportSaleType,
          meta: { title: 'รายงานขายตามประเภทรับชำระ', group_id: 6, menu_id: 16 }
        },
        {
          path: '/calendar',
          name: 'calendar',
          component: Calendar,
          meta: { title: 'ปฏิทินนัดหมาย', group_id: 12, menu_id: 0 }
        },
        {
          path: '/setting',
          name: 'setting',
          component: Setting,
          meta: { title: 'ตั้งค่าระบบ', group_id: 13, menu_id: 18 }
        },
        {
          path: '/role_menage',
          name: 'role_menage',
          component: RoleList,
          meta: { title: 'จัดการสิทธิ์ผู้ใช้งาน', group_id: 13, menu_id: 20 }
        },
        {
          path: '/role_menage_detail/:role_code',
          name: 'role_menage_detail',
          component: RoleMenage,
          meta: { title: 'จัดการสิทธิ์ผู้ใช้งาน', group_id: 13, menu_id: 20 }
        },
        {
          path: '/profile',
          name: 'profile',
          component: Profile,
          meta: { title: 'ข้อมูลผู้ใช้งานระบบ', group_id: 1, menu_id: 1 }
        },
        {
          path: '/vendor',
          name: 'vendor',
          component: Vendor,
          meta: { title: 'จัดการข้อมูลเจ้าหนี้', group_id: 8, menu_id: 0 }
        },
        {
          path: '/customer',
          name: 'customer',
          component: Customer,
          meta: { title: 'จัดการข้อมูลลูกหนี้', group_id: 9, menu_id: 0 }
        },
        {
          path: '/managebill',
          name: 'managebill',
          component: ManageBill,
          meta: { title: 'จัดการบิล', group_id: 8, menu_id: 17 }
        },
        {
          path: '/paycredit',
          name: 'paycredit',
          component: PaymentCreditBill,
          meta: { title: 'รับชำระเงินเชื่อ', group_id: 9, menu_id: 18 }
        },
        {
          path: '/printinv',
          name: 'printinv',
          component: PrintInv,
          meta: { title: 'รายการพักบิล', group_id: 10, menu_id: 0 }
        },
        {
          path: '/tax_invoice',
          name: 'tax_invoice',
          component: TaxInvoice,
          meta: { title: 'จัดการใบกำกับภาษี', group_id: 15, menu_id: 0 }
        },
        {
          path: '/usermenagement',
          name: 'usermenagement',
          component: UserMenagement,
          meta: { title: 'จัดการผู้ใช้งาน', group_id: 13, menu_id: 19 }
        },
        {
          path: '/editusers/:user_code',
          name: 'editusers',
          component: ManageUser,
          meta: { title: 'จัดการผู้ใช้งาน', group_id: 13, menu_id: 19 }
        },
        {
          path: '/adjust_list',
          name: 'adjust_list',
          component: AdjustList,
          meta: { title: 'ปรับปรุงต้นทุนสินค้า', group_id: 3, menu_id: 22 }
        },
        {
          path: '/standart_list',
          name: 'standart_list',
          component: StandardList,
          meta: { title: 'ปรับปรุงต้นทุนสินค้า', group_id: 3, menu_id: 24 }
        },
        {
          path: '/stock_manage',
          name: 'stock_manage',
          component: StkManage,
          meta: { title: 'จัดการโอนย้ายสินค้า', group_id: 3, menu_id: 35 }
        },
        {
          path: '/stock_get_manage',
          name: 'stock_get_manage',
          component: StkGetManage,
          meta: { title: 'สั่งสินค้าโกดัง', group_id: 3, menu_id: 37 }
        },
        {
          path: '/report_income',
          name: 'report_income',
          component: ReportIncome,
          meta: { title: 'รายงานนำเงินเข้า', group_id: 6, menu_id: 25 }
        },
        {
          path: '/report_stock_standard',
          name: 'report_stock_standard',
          component: ReportStockStandard,
          meta: { title: 'รายงานต้นทุนตามสินค้า', group_id: 6, menu_id: 26 }
        },
    
        // {
        //   path: '/short_storage',
        //   name: 'short_storage',
        //   component: ShortStorage,
        //   meta: { title: 'ใบนับสต๊อกสินค้า', group_id: 3, menu_id: 28 }
        // },
        {
          path: '/report_stk',
          name: 'report_stk',
          component: ReportStkList,
          meta: { title: 'รายงานสรุปยอดคงเหลือ', group_id: 3, menu_id: 29 }
        },
        {
          path: '/report_stk_egg',
          name: 'report_stk_egg',
          component: ReportStkEggList,
          meta: { title: 'รายงานสรุปคงเหลือไข่', group_id: 3, menu_id: 36 }
        },
        {
          path: '/stk_balance',
          name: 'stk_balance',
          component: StkBalance,
          meta: { title: 'ยอดยกสินค้ามา', group_id: 3, menu_id: 27 }
        },
        {
          path: '/stk_amount',
          name: 'stk_amount',
          component: StkAmount,
          meta: { title: 'บันทึกนับสต๊อก', group_id: 3, menu_id: 27 }
        },
      // {
      //   path: '/adjust_item',
      //   name: 'adjust_item',
      //   component: AdjustItem,
      //   meta: { title: 'ปรับปรุงต้นทุนสินค้า', group_id: 3, menu_id: 38 }
      // }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { title: 'เข้าสู่ระบบ' }
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: ForgotPass,
      meta: { title: 'ลืมรหัสผ่าน' }
    },
    {
      path: '*',
      name: 'P404',
      component: Error404,
      meta: { title: 'Error Page' }
    }
  ]
})

const DEFAULT_TITLE = titlename
router.afterEach((to, from) => {
  document.title = to.meta.title + titlename || DEFAULT_TITLE + titlename
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js